import { render, staticRenderFns } from "./AvatarUpdateModal.vue?vue&type=template&id=5bc00843&"
import script from "./AvatarUpdateModal.vue?vue&type=script&lang=js&"
export * from "./AvatarUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports